<template>
    <div id="score" title="Review Score">
        <div v-for="(s, i) in solidStars" :key="'fas-' + s" :class="['star', { 'ml-2' : (i > 0) || (i != 0 && solidStars.length == 5) }]" @click="setStars(s)">
            <font-awesome-icon icon="star" :class="[size]" />
        </div>
        <div v-for="(s, i) in regularStars" :key="'far-' + s" :class="['star', { 'ml-2' : (regularStars.length < 5) || (i != 0 && regularStars.length == 5) }]" @click="setStars(solidStars.length + s)">
            <font-awesome-icon :icon="['far', 'star']" :class="['far', size]" />
        </div>
        <small title="Aantal Reviews" v-if="showQty" class="ml-2">({{qty}})</small>
    </div>
</template>

<script>
export default {
    name: 'score',
    props: { 
        score: {
            required: false,
            type: Number,
            default: 5
        },
        size: { 
            type: String,
            default: 'fa-1x'
        },
        qty: {
            type: Number,
            default: 0
        },
        showQty: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rating: this.score
        }
    },
    methods: {
        setStars(rate) {
            if(this.disabled)
                return;

            this.rating = rate + 1;
            this.$emit('update', rate + 1);
        }
    },
    computed: {
        solidStars() {
            let stars = [];
            for(let i = 0; i < this.rating; i++)
            {
                stars.push(i);
            }
            return stars;
        },
        regularStars() {
            let stars = [];
            for(let i = 0; i < 5 - this.solidStars.length; i++)
            {
                stars.push(i);
            }
            return stars;
        }
    },
    watch: {
        score(to) {
            this.rating = to;
        }
    }
}
</script>

<style scoped>
#score {
    display: inline-block;
    min-width: 122px;
    text-align:right;
}
.star {
    display: inline-block;
    color: gold;
}
</style>